import { Navigate, Route, Routes } from 'react-router'
import { PasswordChangeForceLayout } from 'pages/auth/pages/passwordChangeForce/layout/PasswordChangeForceLayout'
import { PasswordChangeForcePage } from 'pages/auth/pages/passwordChangeForce/ui/passwordChangeForcePage'
import { AuthRoutes } from 'pages/auth/route/type'

export const PasswordChangeForceRouter = () => {
  return (
    <Routes>
      <Route element={<PasswordChangeForceLayout />}>
        <Route path={'/'} element={<PasswordChangeForcePage />} />
      </Route>
      <Route
        path={'*'}
        element={<Navigate to={`/${AuthRoutes.root}/${AuthRoutes.passwordChangeForce}`} replace />}
      />
    </Routes>
  )
}
